import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./landingpage.scss";
import { DASHBOARD, SWDASHBOARD } from "../../constant/routeContant";
import { LANDING_CARD } from "../../constant/constant";
import { Grid } from "@mui/material";
import Card from "../../library/custom/cardList/card";
import {
  encryptData,
  getPrivilegeByServiceType,
} from "../../utils/rolesHelper";

const Landingpage = () => {
  const navigate = useNavigate();
  const onClickHandler = (id) => {
    localStorage.setItem("serviceType", id);
    const allPrivileges = JSON.parse(localStorage.getItem("allPrivileges"));
    const encryptedPrivilege = encryptData(
      getPrivilegeByServiceType(allPrivileges, id)
    );
    localStorage.setItem("privileges", encryptedPrivilege);
    if (id === 1) {
      navigate(DASHBOARD);
    } else if (id === 2) {
      navigate(SWDASHBOARD);
    }
  };

  useEffect(() => {
    const serviceType = localStorage.getItem("serviceType");
    if (serviceType && serviceType === 1) {
      navigate(DASHBOARD);
    } else if (serviceType && serviceType === 2) {
      navigate(SWDASHBOARD);
    }
  }, []);

  return (
    <>
      <Grid container className="landingtitle" mt={6}>
        <h2>Select Service</h2>
      </Grid>
      <Grid container>
        <Grid md={2} xs={12}></Grid>
        <Grid
          container
          md={8}
          className="CardListContanerLanding cardsBoxLanding"
          mt={6}
        >
          <Grid md={2} xs={12}></Grid>
          <Card
            iconShow={false}
            onClick={onClickHandler}
            imgShow={true}
            cardDetail={LANDING_CARD[0]}
          />

          <Card
            iconShow={false}
            onClick={onClickHandler}
            imgShow={true}
            cardDetail={LANDING_CARD[1]}
          />

          <Grid md={2} xs={12}></Grid>
        </Grid>
        <Grid md={2} xs={12}></Grid>
      </Grid>
    </>
  );
};

export default Landingpage;
